import React,{useEffect, useState} from "react";
import { Row, Col, Container } from "olive-react-myoneui";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import HelpForm from "../../components/HelpForm";

function HelpFormPage() {
  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <div className="w-100 bg-light-gray" style={{padding:'70px 10px'}}>
        <Container>
          <Row>
            <Col lg={12}>
              <HelpForm />
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default HelpFormPage;
